import React from 'react';

export function Logo() {
    //className="img-fluid"
    return (
        <img src="/logo.png" alt="logo" className="img-fluid"/>
    );
}

